export const EDIT_CONTRACT_NOTES_MODAL_NAME = 'EDIT_CONTRACT_NOTES_MODAL_NAME';
